import React from 'react'
import { Route, Routes } from 'react-router-dom'
import AboutUs from '../pages/aboutus/AboutUs'

export default function AboutUsRoutes() {
  return (
    <Routes>
        <Route path='/' element={<AboutUs />} />
    </Routes>
  )
}